"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Adds an ORDER ITEM to an order.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type OrderPayment
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a;
    let order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    let itemStatus = order.status === domain_1.OrderStatus.DRAFT
        ? domain_1.OrderItemStatus.DRAFT
        : domain_1.OrderItemStatus.CREATED;
    if (order.status === domain_1.OrderStatus.ON_HOLD) {
        itemStatus = domain_1.OrderItemStatus.ON_HOLD;
    }
    order.orderItems.push({
        id: event.id,
        product: {
            id: event.productId,
            name: event.productName,
            optionValues: event.optionValues || [],
            alternateNames: (event === null || event === void 0 ? void 0 : event.alternateNames) || [],
            variableQuantity: (event === null || event === void 0 ? void 0 : event.variableQuantity) || false,
            measuredBy: event === null || event === void 0 ? void 0 : event.measuredBy,
            ...((event === null || event === void 0 ? void 0 : event.isVariantProductNameChanged) && {
                isVariantProductNameChanged: event === null || event === void 0 ? void 0 : event.isVariantProductNameChanged,
            }),
            ...(event.categoryId && {
                category: {
                    id: event.categoryId,
                },
            }),
        },
        status: event.fireItem ? itemStatus : domain_1.OrderItemStatus.ON_HOLD,
        quantity: event.quantity,
        priority: event.priority,
        pagePriority: event.pagePriority,
        taxInclusive: event.taxInclusive,
        unitPrice: event.unitPrice,
        taxes: event.taxes,
        costPrice: event.costPrice,
        variant: event.variantId
            ? {
                id: event.variantId,
                name: event.variantName,
                alternateNames: (event === null || event === void 0 ? void 0 : event.variantAlternateNames) || [],
            }
            : null,
        modifiers: event.modifiers || [],
        course: event.courseId
            ? {
                id: event.courseId,
                name: event.courseName || '',
                priority: (_a = event.coursePriority) !== null && _a !== void 0 ? _a : 0,
            }
            : null,
        discounts: [],
        discountAmount: 0,
        seatNumber: event.seatNumber,
        createdAt: event.timestamp,
        printerProfiles: event.printerProfiles || [],
        ...(event.tareWeight && {
            tareWeight: event.tareWeight,
        }),
    });
    order = {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
        lastOrderedAt: event.timestamp,
    };
    return order;
}
exports.default = default_1;
//# sourceMappingURL=addOrderItem.js.map